import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let AIPolishDesign = class AIPolishDesign extends Vue {
};
AIPolishDesign = tslib_1.__decorate([
    Component({ name: "AIPolishDesign" })
], AIPolishDesign);
export default AIPolishDesign;
